import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import { RouterLink } from '@angular/router';
import { DeviceType } from '../devices.models';
import { MeterTable } from 'src/app/services/data/devices-data/devices-data.types';
import { getUrlPathForDeviceTypeName } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model.helpers';
import { Commodity } from '@portal/shared/types/commodity.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  template: `<a
    [routerLink]="link()"
    [relativeTo]="null"
    >{{ text() }}</a
  >`
})
export class CommDeviceIdColumnComponent {
  item = input.required<MeterTable>();
  column = input.required<TableColumn>();

  protected readonly text = computed(() => `${this.item().commDeviceId ?? this.item().parentCommDeviceId ?? ''}`);

  protected readonly link = computed(() => {
    const item = this.item();
    const isElectricMeter = item.deviceType === DeviceType.Meter && item.commodity === Commodity.Electricity;
    return isElectricMeter
      ? `devices/${getUrlPathForDeviceTypeName(item.deviceType)}/${item.deviceUID}`
      : `devices/${getUrlPathForDeviceTypeName(item.deviceType)}/${item.parentDeviceUID ?? item.deviceUID}`;
  });
}
